import { web } from "./middleware";

export const SettingsApi = {
  getNotificationSettings: () =>
    web({ url: "/settings/notifications", method: "GET" }),
  updateNotificationSettings: (data) =>
    web({
      url: "/settings/notifications",
      method: "POST",
      data,
    }),
};

export default SettingsApi;
